export default "__VITE_ASSET__DJ8WBlF4__";